import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { Loader, Center, Stack, Text } from '@mantine/core';

/**
 * MineMinerRoute - Route guard for MineMiner feature (epic-006, sprint-069)
 *
 * Requires authentication AND MineMinerRep or MineMinerAdmin role.
 * MineMinerAdmin implicitly satisfies MineMinerRep (admin implies rep).
 *
 * Redirects:
 * - Unauthenticated users to / (marketing homepage)
 * - Authenticated users without a MineMiner role to /access-denied
 */
export const MineMinerRoute: React.FC = (): React.ReactElement => {
  const { isAuthenticated, isMineMinerRep, isLoading } = useAuth();

  if (isLoading) {
    return (
      <Center h="100vh">
        <Stack align="center" gap="md">
          <Loader size="lg" />
          <Text size="sm" c="dimmed">
            Loading...
          </Text>
        </Stack>
      </Center>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (!isMineMinerRep) {
    return <Navigate to="/access-denied" replace />;
  }

  return <Outlet />;
};
